import { request } from "@/util/http";

export const getAbnormalLogList = (current, size, params) => {
  return request({
    url: "/log/dataabnormallog/list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getAbnormalLogLikeList = (current, size) => {
  return request({
    url: "/log/dataabnormallog/listLike",
    method: "get",
    params: {
      current,
      size,
    },
  });
};

export const getAbnormalLogs = (id) => {
  return request({
    url: "/log/dataabnormallog/detail",
    method: "get",
    params: {
      id,
    },
  });
};

export const getDataAbnormalLogList = (current, size, params) => {
  return request({
    url: "/log/dataabnormallog/getDataAbnormalLogList",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};
